module.exports = "<div class=\"cgp-full-screen-tap-container\"></div>\r\n";